/* NA LEIBERL – Deutsche Bezeichnungen fuer Texte, die nicht aus dem Theme kommen
   (Produktoptionen aus Gelato wie "Size", Filternamen aus Search & Discovery wie "Availability").
   Ersetzt nur das erste Wort am Anfang eines Textes in bestimmten Bereichen
   (Warenkorb, Filter inkl. aktiver Filter-Pillen, Variantenauswahl). */
(function () {
  var MAP = {
    'Size': 'Größe',
    'Color': 'Farbe',
    'Colour': 'Farbe',
    'Availability': 'Verfügbarkeit',
    'Price': 'Preis',
    'Product type': 'Produktart',
    'Brand': 'Marke',
    'In stock': 'Auf Lager',
    'Out of stock': 'Nicht vorrätig'
  };
  var SCOPES = [
    '.cart-item__details', '.cart-items', '.cart-drawer', 'cart-drawer-items', '.cart-notification',
    '.facets-wrapper', '.mobile-facets', '.facets-container', 'facet-filters-form', '.active-facets', 'facet-remove',
    'variant-selects', '.product-form__input'
  ].join(',');
  var keys = Object.keys(MAP).sort(function (a, b) { return b.length - a.length; })
    .map(function (k) { return k.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); });
  // Wort am Anfang (nach Leerraum/Zeilenumbruch), danach Textende, Doppelpunkt oder Klammer (Rest beliebig, auch mehrzeilig)
  var RE = new RegExp('^(\\s*)(' + keys.join('|') + ')(?=\\s*(?:$|[:(]))([\\s\\S]*)$');

  function translate(t) {
    var m = t && t.match(RE);
    return m ? m[1] + MAP[m[2]] + m[3] : t;
  }
  function fixNode(n) {
    var t = n.nodeValue;
    if (!t || !t.trim()) return;
    var nv = translate(t);
    if (nv !== t) n.nodeValue = nv;
  }
  function fixAttr(el) {
    var a = el.getAttribute('aria-label');
    if (!a) return;
    var nv = translate(a);
    if (nv !== a) el.setAttribute('aria-label', nv);
  }
  function run(root) {
    var areas = root.querySelectorAll ? root.querySelectorAll(SCOPES) : [];
    Array.prototype.forEach.call(areas, function (area) {
      var w = document.createTreeWalker(area, NodeFilter.SHOW_TEXT, null);
      var n; while ((n = w.nextNode())) fixNode(n);
      Array.prototype.forEach.call(area.querySelectorAll('[aria-label]'), fixAttr);
    });
  }
  var scheduled = false;
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(function () { scheduled = false; run(document); });
  }
  function init() {
    run(document);
    new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true, characterData: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
